
import { useTranslation } from "react-i18next";
import { Building2, Users, Briefcase, UserCog, GraduationCap } from "lucide-react";
import { Link } from "react-router-dom";

const TargetAudience = () => {
  const { t } = useTranslation(["targetAudience"]);

  const targets = [
    {
      icon: <Building2 className="w-8 h-8 text-brand-orange" />,
      title: t('targets.hr.title'),
      description: t('targets.hr.description'),
      link: "/drh"
    },
    {
      icon: <UserCog className="w-8 h-8 text-brand-orange" />,
      title: t('targets.recruiters.title'),
      description: t('targets.recruiters.description'),
      link: "/recruteurs"
    },
    {
      icon: <Users className="w-8 h-8 text-brand-orange" />,
      title: t('targets.individuals.title'),
      description: t('targets.individuals.description'),
      link: "/particuliers"
    },
    {
      icon: <GraduationCap className="w-8 h-8 text-brand-orange" />,
      title: t('targets.training.title'),
      description: t('targets.training.description'),
      link: "/formations"
    }
  ];

  return (
    <section className="py-24 bg-background">
      <div className="container-custom">
        <h2 className="text-4xl sm:text-5xl font-bold text-center mb-16 bg-clip-text text-transparent bg-gradient-to-r from-brand-blue to-brand-orange leading-tight">
          {t('title')}
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
          {targets.map((target, index) => (
            <div 
              key={index}
              className="group bg-card rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-border flex flex-col"
            >
              <div className="p-3 bg-brand-orange/10 dark:bg-brand-orange/5 rounded-lg w-fit mb-4 group-hover:scale-110 transition-transform">
                {target.icon}
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-3 group-hover:text-brand-orange transition-colors min-h-[56px] flex items-center">
                {target.title}
              </h3>
              <div className="flex flex-col flex-grow justify-between">
                <p className="text-muted-foreground mb-6">
                  {target.description}
                </p>
                <Link 
                  to={target.link}
                  className="inline-flex items-center text-brand-orange hover:text-brand-blue transition-colors"
                >
                  {t('learnMore')}
                  <svg 
                    className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M9 5l7 7-7 7" 
                    />
                  </svg>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TargetAudience;
